import { z } from 'zod'
import type { ErrorCode } from './constants/errors'

// Progress recording API schema
export const recordProgressSchema = z.object({
  playedSecondsChunk: z
    .number()
    .min(0)
    .transform((v) => Math.round(v)),
  isNewPlayEvent: z.boolean(),
})

export type RecordProgressInput = z.infer<typeof recordProgressSchema>

// Video duration API schema
export const videoDurationSchema = z.object({
  totalDurationSeconds: z.number().int().positive(),
})

export type VideoDurationInput = z.infer<typeof videoDurationSchema>

// API Response types
export interface ApiResponse<T = unknown> {
  success: true
  data: T
  pagination?: PaginationMeta
}

export interface ApiErrorResponse {
  success: false
  error: string
  code?: ErrorCode
}

export interface PaginationMeta {
  page: number
  limit: number
  total: number
  totalPages: number
}

export interface ProgressResponse {
  playedSeconds: number
  hasCompleted: boolean
  percentage: number
}

export interface CourseProgress {
  total: number
  completed: number
  percentage: number
}

export const CourseProgressSchema = z.object({
  total: z.number().min(0),
  completed: z.number().min(0),
  percentage: z.number().min(0).max(100),
})
